import { useState } from "react";
import type { TablePaginationConfig } from "antd/es/table";

interface ServiceParams {
  page?: number | undefined;
  perPage?: number | undefined;
  total?: number | undefined;
  [key: string]: any;
}

interface TableParams {
  pagination: TablePaginationConfig;
  filters?: any;
  sorter?: any;
}

interface UsePaginationParams {
  service: (params: ServiceParams) => Promise<any>;
  [key: string]: any;
}

export const usePagination = () => {
  const [tableParams, setTableParams] = useState<TableParams>({
    pagination: {
      current: 1,
      pageSize: 10,
      pageSizeOptions: ["5", "10", "20", "50"],
      showSizeChanger: true,
      position: ["bottomCenter"],
    },
  });

  const onTableChange = (
    pagination: TablePaginationConfig,
    filters: any,
    sorter: any,
  ) => {
    setTableParams({
      pagination,
      filters,
      sorter: {
        field: sorter.field,
        order: sorter.order,
      },
    });
  };

  const resetPagination = () => {
    setTableParams({
      pagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ["5", "10", "20", "50"],
        showSizeChanger: true,
        position: ["bottomCenter"],
      },
    });
  };

  const getFilters = () => {
    let filters: any = {};
    if (tableParams.filters) {
      Object.keys(tableParams.filters).forEach((key) => {
        if (tableParams.filters[key]) {
          filters[key] = tableParams.filters[key][0];
        }
      });
    }
    return filters;
  };

  const getSorter = () => {
    let sorter: any = {};
    if (tableParams.sorter) {
      sorter = {
        field: tableParams.sorter.field,
        order: tableParams.sorter.order,
      };
    }
    return sorter;
  };

  return {
    getFilters,
    getSorter,
    onTableChange,
    resetPagination,
    tableParams,
  };
};
